import { useDispatch, useSelector } from "react-redux";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import { addDays, tileDisabled } from "../helpers/dateUtils";
import {
  setIsModalOpen,
  setName,
  setEmail,
  setPhone,
  startChangetDate,
  requestAppointment,
  setTime,
} from "../actions/appointments";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function AppointmentModal(props) {
  const dispatch = useDispatch();
  const show = useSelector(
    (state) => state.appointment.appointment.isModalOpen
  );

  const selectedDate = useSelector(
    (state) => state.appointment.appointment.date
  );
  const selectedName = useSelector(
    (state) => state.appointment.appointment.name
  );
  const selectedEmail = useSelector(
    (state) => state.appointment.appointment.email
  );
  const selectedPhone = useSelector(
    (state) => state.appointment.appointment.phone
  );

  const selectedTime = useSelector(
    (state) => state.appointment.appointment.time
  );

  const availableTimeSlots = useSelector(
    (state) => state.appointment.appointment.availableTimeSlots
  );

  function convertToOptions(object) {
    let array = [];
    for (const property in object) {
      array.push({ value: object[property], label: property });
    }
    return array;
  }

  function openModalHandler() {
    dispatch(setIsModalOpen(true));
  }

  function closeModalHandler() {
    dispatch(setIsModalOpen(false));
  }

  const requestAppointmentModalHandler = () => {
    console.log("request appointment");
    dispatch(
      requestAppointment(
        props.property.id,
        selectedDate,
        selectedTime,
        selectedName,
        selectedEmail,
        selectedPhone
      )
    );
  };

  const onChangeCalendar = (newDate) => {
    dispatch(startChangetDate(newDate));
  };

  const onChangeTime = (event) => {
    dispatch(setTime(event.currentTarget.value));
  };

  const onChangeName = (event) => {
    dispatch(setName(event.target.value));
  };

  const onChangePhone = (event) => {
    dispatch(setPhone(event.target.value));
  };

  const onChangeEmail = (event) => {
    dispatch(setEmail(event.target.value));
  };

  return (
    <>
      <Button variant="primary" onClick={openModalHandler}>
        Solicitar cita
      </Button>

      <Modal show={show} onHide={closeModalHandler}>
        <Modal.Header closeButton>
          <Modal.Title>Solicitud de cita</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Primero selecciona el dia</p>
          <Calendar
            className="center-calendar"
            locale="es-ES"
            maxDate={addDays(new Date(), 7)}
            minDate={addDays(new Date(), 1)}
            tileDisabled={tileDisabled} //{({ date }) => [0, 6].includes(date.getDay())} //Disable Saturdays & Sundays
            calendarType="gregory"
            onChange={onChangeCalendar}
            defaultValue={selectedDate}
          />
          <p>Hora</p>
          <Form.Select
            aria-label="Default select example"
            onChange={onChangeTime}
            value={selectedTime}
          >
            {convertToOptions(availableTimeSlots).map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlInputName"
            >
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ana Perez"
                onChange={onChangeName}
                defaultValue={selectedName}
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlInpuPhone"
            >
              <Form.Label>Celular</Form.Label>
              <Form.Control
                type="phone"
                placeholder="301XXXXXXX"
                onChange={onChangePhone}
                defaultValue={selectedPhone}
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlInputEmail"
            >
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="ana.perez@ejemplo.com"
                onChange={onChangeEmail}
                defaultValue={selectedEmail}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalHandler}>
            Cerrar
          </Button>
          <Button
            variant="primary"
            disabled={!selectedName || !selectedPhone || !selectedEmail}
            onClick={requestAppointmentModalHandler}
          >
            Solicitar cita
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AppointmentModal;
